/**
 * Забирает базовую конфигурацию сервера из HTML
 * которая генерируется на сервере виджетом
 * 
 */
class ServerConfigFromHtml
{
    private static _instance: ServerConfigFromHtml

    public documentElementId: string = 'server-config-to-html-v1';

    public config: {} = {};

    public static get Instance() {
        return this._instance || (this._instance = new this());
    }

    private constructor() {
        this.config = JSON.parse(document.getElementById(this.documentElementId)
            ?.getAttribute('data-config') || '{}');
    }
}

export const serverConfigFromHtmlInstance = ServerConfigFromHtml.Instance;